import React, { JSXElementConstructor, ReactElement } from 'react'
import TooltipLib from 'rc-tooltip'

import { Plus } from 'lucide-react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { Button } from '@/components/v2/Button'
import {
  Tooltip as TooltipV2,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  TooltipArrow,
} from '@/components/v2/Tooltip'

interface TooltipProps {
  title?: JSX.Element | string
  position?: 'right' | 'left' | 'bottom' | 'top'
  children: ReactElement<any, string | JSXElementConstructor<any>> | undefined
}

export default function Tooltip({
  position,
  title,
  children,
  ...rest
}: TooltipProps &
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Root>) {
  return (
    <TooltipProvider>
      <TooltipV2 {...rest}>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className="z-20" side={position}>
          <div>{title}</div>
          <TooltipArrow />
        </TooltipContent>
      </TooltipV2>
    </TooltipProvider>
  )
}
